export default {
    namespaced: true,
    getters: {
        deliveryServiceName: (state, getters) => (serviceId) => {
            return getters.configValue('deliveryServices', serviceId);
        },

        deliveryMethods (state) {
            return state.deliveryMethods || [];
        },

        deliveryMethodName: (state, getters) => (methodId) => {
            return getters.configValue('deliveryMethods', methodId);
        },

        paymentTypeName: (state, getters) => (typeId) => {
            return getters.configValue('paymentTypes', typeId);
        },

        configValue: (state) => (param, id) => {
            let values = state[param] || [];

            let value = values.find(item => item.id === id);

            return value ? value.name : '';
        }
    },
    mutations: {
        set (state, assets) {
            for (let key in assets) {
                Vue.set(state, key, assets[key]);
            }
        }
    },
}
